import { Outlet, ScrollRestoration } from 'react-router';
import { ToastProvider } from '../components/ui/Toast.tsx';
import { AuthProvider } from '../lib/auth.tsx';
import { RealtimeProvider } from '../lib/realtime.ts';

/** Providers that need the router (navigation) wrap every route. */
export function RootLayout() {
  return (
    <ToastProvider>
      <AuthProvider>
        <RealtimeProvider>
          <Outlet />
        </RealtimeProvider>
      </AuthProvider>
      <ScrollRestoration />
    </ToastProvider>
  );
}
